import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import FalconReactRange from '@/app/BacklinkNew/components/FalconReactRange';
import { useRef } from 'react';
import type { AgGridChangeHeightProps } from './types';

const AgGridChangeHeight = ({
  heightState,
  setHeightState
}: AgGridChangeHeightProps) => {
  const popoverRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div ref={popoverRef} className="position-relative">
        <OverlayTrigger
          container={popoverRef.current}
          trigger="click"
          rootClose
          placement="top"
          overlay={
            <Popover
              id="popover-basic"
              style={{ width: '350px', position: 'absolute' }}
            >
              <Popover.Header
                as="h3"
                className="d-flex justify-content-between align-items-center"
              >
                تغییر ارتفاع جدول
                <span className="fs--1" style={{ direction: 'ltr' }}>
                  {heightState}
                </span>
              </Popover.Header>
              <Popover.Body className="px-3 py-2">
                <div dir="ltr">
                  <FalconReactRange
                    step={1}
                    variant="primary"
                    max={2000}
                    min={200}
                    values={[heightState]}
                    onChange={(val: number[]) =>
                      setHeightState(Number(val[0]))
                    }
                    tipFormatter={undefined}
                    rtl={undefined}
                  />
                  <div className="d-flex justify-content-between">
                    <span>200px</span>
                    <span>2000px</span>
                  </div>
                </div>
              </Popover.Body>
            </Popover>
          }
        >
          <Button
            style={{ width: '30px', height: '30px' }}
            title="تغییر ارتفاع"
            variant="outline-secondary"
            size="sm"
            className="d-flex align-items-center justify-content-center"
          >
            <FontAwesomeIcon icon="arrows-alt-v" className="fs--1" />
          </Button>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default AgGridChangeHeight;
